import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **Document Your APIs in HawkClient**

HawkClient makes it easy to keep your APIs well-documented by supporting **Markdown-based documentation** at the **collection**, **folder** and **request** levels.

- **Collection-Level Documentation** – Click the *Manage* option from the collection dropdown to access the **Overview** tab.  
  On the left, you can write rich Markdown documentation for the entire collection.  
  On the right, you’ll see workspace and collection location details for quick context.

- **Folder-Level Documentation** – Click the *Manage* option from the folder dropdown to access the **Overview** tab.  
  On the left, you can write rich Markdown documentation for the entire collection.  
  On the right, you’ll see workspace and folder location details for quick context.

- **Request-Level Documentation** – Open any request and navigate to the **Docs** tab to describe request-specific details such as purpose, parameters, headers, expected responses, and any other helpful notes—all using Markdown.

With Markdown support built-in, HawkClient lets you maintain clear and collaborative API documentation directly within your workspace.
`;

const APIDocumentationOverview = () => {
    return (
        <MarkDownRenderer
            title="API Documentation Overview"
            markDownText={markdownContent}
        />
    );
};

export default APIDocumentationOverview;
